import { Controller } from '@hotwired/stimulus'
import { Tab } from 'bootstrap'
import TomSelect from 'tom-select'
import i18next from 'i18next'

import { getExportTemplates } from '../../../services/organizationsService'
import { ApiService } from '../../../services/apiService'

// Connects to data-controller="sites--exports--form"
export default class extends Controller {
  static targets = [
    'tabPreview',
    'previewer',
    'showPrices',
    'isEstimate',
    'includeTasksExcludedFromBillOfQuantities',
    'selectSupplier',
    'selectTags',
    'selectTaskCategories',
    'exportTemplateId',
    'mainText',
    'boxText',
    'sideText',
  ];
  static values = {
    organizationId: String,
    projectId: String,
    siteId: String,
  }

  connect() {
    this.initSupplierSelect()
    this.initTagsSelect()
    this.initTaskCategoriesSelect()
    this.initExportTemplateIdSelect()
    this.showPricesChanged()
    this.loadOrganizationTemplates(this.organizationIdValue)
  }

  showPricesChanged() {
    const showPrices = this.showPricesChecked
    this.isEstimateTarget.checked = this.isEstimateTarget.checked && showPrices
    this.isEstimateTarget.disabled = !showPrices
    this.exportRequest()
  }

  get showPricesChecked() {
    return this.hasShowPricesTarget && this.showPricesTarget.checked
  }

  initSupplierSelect() {
    this.selectSupplierSelect = new TomSelect(
      this.selectSupplierTarget,
      {
        plugins: ['remove_button'],
        selectOnTab: true,
        valueField: 'id',
        labelField: 'name',
        closeAfterSelect: true,
      },
    )
  }

  initTagsSelect() {
    this.selectTagsSelect = new TomSelect(
      this.selectTagsTarget,
      {
        plugins: ['remove_button'],
        selectOnTab: true,
        valueField: 'id',
        labelField: 'name',
        closeAfterSelect: true,
      },
    )
  }

  initTaskCategoriesSelect() {
    this.selectTaskCategoriesSelect = new TomSelect(
      this.selectTaskCategoriesTarget,
      {
        plugins: ['remove_button'],
        selectOnTab: true,
        valueField: 'id',
        labelField: 'name',
        closeAfterSelect: true,
      },
    )
  }

  async loadOrganizationTemplates(organizationId) {
    this.exportTemplateIdSelect.clear()
    this.exportTemplateIdSelect.clearOptions()
    const exportTemplates = (await getExportTemplates(organizationId)).data;
    if (exportTemplates.length > 0) {
      this.exportTemplateIdSelect.enable()
      this.exportTemplateIdSelect.addOptions(exportTemplates)
      this.exportTemplateIdSelect.refreshOptions(false)
    } else {
      this.exportTemplateIdSelect.disable()
    }
  }

  initExportTemplateIdSelect() {
    this.exportTemplateIdSelect = new TomSelect(this.exportTemplateIdTarget, {
      valueField: 'id',
      labelField: 'name',
      placeholder: i18next.t('views.export_templates.select_template'),
      plugins: {
        remove_button: {
          title: i18next.t('command.remove'),
        },
      },
      onChange: () => this.exportRequest(),
    })
  }

  clearPreviewer() {
    new Tab(this.tabPreviewTarget).show();
    this.element.disabled = true;
    this.previewerTarget.srcdoc = ''
  }

  enablePreviewer(html) {
    this.element.disabled = false;
    this.previewerTarget.srcdoc = html
  }

  async exportRequest() {
    this.clearPreviewer()
    const response = await ApiService.post(`/projects/${this.projectIdValue}/sites/${this.siteIdValue}/sites/exports`, {
      export: {
        format: 'preview',
        show_prices: this.showPricesChecked,
        is_estimate: this.isEstimateTarget.checked,
        include_tasks_excluded_from_bill_of_quantities:
          this.hasIncludeTasksExcludedFromBillOfQuantitiesTarget
          && this.includeTasksExcludedFromBillOfQuantitiesTarget.checked,
        supplier_id: this.selectSupplierSelect.getValue(),
        tag_ids: this.selectTagsSelect.getValue(),
        task_category_ids: this.selectTaskCategoriesSelect.getValue(),
        export_template_id: this.exportTemplateIdSelect.getValue(),
        main_text: this.mainTextTarget.value,
        box_text: this.boxTextTarget.value,
        side_text: this.sideTextTarget.value,
      },
    })
    this.enablePreviewer(await response.text())
  }
}
